"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var AlertAction;
(function (AlertAction) {
    AlertAction.ON_SEARCH_SET_ALERT_CHANGED = 'ON_SEARCH_SET_ALERT_CHANGED';
    AlertAction.ON_CHANGE_SAVE_SEARCH_ALERT = 'ON_CHANGE_SAVE_SEARCH_ALERT';
    AlertAction.ON_CHANGE_SAVE_SEARCH_EMAIL_ENABLED = 'ON_CHANGE_SAVE_SEARCH_EMAIL_ENABLED';
    AlertAction.ON_CHANGE_SAVE_SEARCH_MOBILE_ENABLED = 'ON_CHANGE_SAVE_SEARCH_MOBILE_ENABLED';
    AlertAction.ON_CHANGE_FOLLOWING_EMAIL_ENABLED = 'ON_CHANGE_FOLLOWING_EMAIL_ENABLED';
    AlertAction.ON_CHANGE_FOLLOWING_MOBILE_ENABLED = 'ON_CHANGE_FOLLOWING_MOBILE_ENABLED';
    AlertAction.ON_CHANGE_MARKET_UPDATE = 'ON_CHANGE_MARKET_UPDATE';
    AlertAction.ON_CLICK_ALL_SAVED_SEARCHES_MOBILE = 'ON_CLICK_ALL_SAVED_SEARCHES_MOBILE';
    AlertAction.ON_CLICK_ALL_SAVED_SEARCHES_EMAIL = 'ON_CLICK_ALL_SAVED_SEARCHES_EMAIL';
    AlertAction.ON_CLICK_ALL_FOLLOWING_PLACES_MOBILE = 'ON_CLICK_ALL_FOLLOWING_PLACES_MOBILE';
    AlertAction.ON_CLICK_ALL_FOLLOWING_PLACES_EMAIL = 'ON_CLICK_ALL_FOLLOWING_PLACES_EMAIL';
    AlertAction.SET_MARKET_UPDATE = 'SET_MARKET_UPDATE';
    AlertAction.SET_SAVE_SERACH_ALERT_ENABLED = 'SET_SAVE_SERACH_ALERT_ENABLED';
    AlertAction.ON_ALERT_SAVE = 'ON_ALERT_SAVE';
    AlertAction.SET_ALERT_SAVED_SEARCHES = 'SET_ALERT_SAVED_SEARCHES';
    AlertAction.SET_ALERT_FOLLOWS = 'SET_ALERT_FOLLOWS';
    AlertAction.SET_ALERT_LOADING = 'SET_ALERT_LOADING';
    AlertAction.SET_SAVE_SEARCH_SET_CHANNEL = 'SET_SAVE_SEARCH_SET_CHANNEL';
    AlertAction.SET_SAVE_SEARCH_SET_ENABLED = 'SET_SAVE_SEARCH_SET_ENABLED';
    AlertAction.SET_FOLLOWING_PLACES_CHANNEL = 'SET_FOLLOWING_PLACES_CHANNEL';
    AlertAction.SET_FOLLOWING_PLACES_ENABLED = 'SET_FOLLOWING_PLACES_ENABLED';
    AlertAction.ON_UNSUBSCRIBE_CLICKED = 'ON_UNSUBSCRIBE_CLICKED';
    AlertAction.onSearchSetAlertChanged = typesafe_actions_1.createAction(AlertAction.ON_SEARCH_SET_ALERT_CHANGED, function (resolve) { return function () { return resolve(); }; });
    AlertAction.onChangeSaveSearchAlert = typesafe_actions_1.createAction(AlertAction.ON_CHANGE_SAVE_SEARCH_ALERT, function (resolve) {
        return function (id, frequency) { return resolve({ id: id, frequency: frequency }); };
    });
    AlertAction.onChangeSaveSearchEmailEnabled = typesafe_actions_1.createAction(AlertAction.ON_CHANGE_SAVE_SEARCH_EMAIL_ENABLED, function (resolve) {
        return function (id) { return resolve(id); };
    });
    AlertAction.onChangeSaveSearchMobileEnabled = typesafe_actions_1.createAction(AlertAction.ON_CHANGE_SAVE_SEARCH_MOBILE_ENABLED, function (resolve) {
        return function (id) { return resolve(id); };
    });
    AlertAction.onChangeFollowingEmailEnabled = typesafe_actions_1.createAction(AlertAction.ON_CHANGE_FOLLOWING_EMAIL_ENABLED, function (resolve) {
        return function (id) { return resolve(id); };
    });
    AlertAction.onChangeFollowingMobileEnabled = typesafe_actions_1.createAction(AlertAction.ON_CHANGE_FOLLOWING_MOBILE_ENABLED, function (resolve) {
        return function (id) { return resolve(id); };
    });
    AlertAction.onChangeMarketUpdate = typesafe_actions_1.createAction(AlertAction.ON_CHANGE_MARKET_UPDATE, function (resolve) { return function () { return resolve(); }; });
    AlertAction.onClickAllSavedSearchesEmail = typesafe_actions_1.createAction(AlertAction.ON_CLICK_ALL_SAVED_SEARCHES_EMAIL, function (resolve) { return function () { return resolve(); }; });
    AlertAction.onClickAllFollowingPlacesEmail = typesafe_actions_1.createAction(AlertAction.ON_CLICK_ALL_FOLLOWING_PLACES_EMAIL, function (resolve) { return function () { return resolve(); }; });
    AlertAction.onClickAllSavedSearchesMobile = typesafe_actions_1.createAction(AlertAction.ON_CLICK_ALL_SAVED_SEARCHES_MOBILE, function (resolve) { return function () { return resolve(); }; });
    AlertAction.onClickAllFollowingPlacesMobile = typesafe_actions_1.createAction(AlertAction.ON_CLICK_ALL_FOLLOWING_PLACES_MOBILE, function (resolve) { return function () { return resolve(); }; });
    AlertAction.setMarketUpdate = typesafe_actions_1.createAction(AlertAction.SET_MARKET_UPDATE, function (resolve) { return function (state) { return resolve(state); }; });
    AlertAction.setSaveSearchAlertEnabled = typesafe_actions_1.createAction(AlertAction.SET_SAVE_SERACH_ALERT_ENABLED, function (resolve) {
        return function (id, frequency) {
            return resolve({ id: id, frequency: frequency });
        };
    });
    AlertAction.onAlertSave = typesafe_actions_1.createAction(AlertAction.ON_ALERT_SAVE, function (resolve) { return function () {
        return resolve();
    }; });
    AlertAction.onUnsubscribeClicked = typesafe_actions_1.createAction(AlertAction.ON_UNSUBSCRIBE_CLICKED, function (resolve) { return function () {
        return resolve();
    }; });
    AlertAction.setSavedSearches = typesafe_actions_1.createAction(AlertAction.SET_ALERT_SAVED_SEARCHES, function (resolve) { return function (savedSearches) {
        return resolve(savedSearches);
    }; });
    AlertAction.setFollows = typesafe_actions_1.createAction(AlertAction.SET_ALERT_FOLLOWS, function (resolve) { return function (follows) {
        return resolve(follows);
    }; });
    AlertAction.setIsLoading = typesafe_actions_1.createAction(AlertAction.SET_ALERT_LOADING, function (resolve) { return function (state) {
        return resolve(state);
    }; });
    AlertAction.setSaveSearchSetChannel = typesafe_actions_1.createAction(AlertAction.SET_SAVE_SEARCH_SET_CHANNEL, function (resolve) { return function (id, channel) {
        return resolve({ id: id, channel: channel });
    }; });
    AlertAction.setFollowingPlacesChannel = typesafe_actions_1.createAction(AlertAction.SET_FOLLOWING_PLACES_CHANNEL, function (resolve) { return function (id, channel) {
        return resolve({ id: id, channel: channel });
    }; });
    AlertAction.setSaveSearchSetEnabled = typesafe_actions_1.createAction(AlertAction.SET_SAVE_SEARCH_SET_ENABLED, function (resolve) { return function (id, enabled) {
        return resolve({ id: id, enabled: enabled });
    }; });
    AlertAction.setFollowingPlacesEnabled = typesafe_actions_1.createAction(AlertAction.SET_FOLLOWING_PLACES_ENABLED, function (resolve) { return function (id, enabled) {
        return resolve({ id: id, enabled: enabled });
    }; });
})(AlertAction || (AlertAction = {}));
exports.default = AlertAction;
